<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
            <div class="title">{{this.$store.state.parameters.scheme.schemeMenu.sideMenuTitle}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.planNo}}</v-subheader>
            <div class="title">{{this.$store.state.parameters.scheme.pkgPlanMenu.pkgPlanTitle}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.riskNo}}</v-subheader>
            <div class="title">{{this.$store.state.parameters.scheme.pkgRiskMenu.pkgRiskTitle}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.itemNo}}</v-subheader>
            <div class="title">{{this.$store.state.parameters.scheme.pkgRiskItemMenu.pkgRiskItemTitle}}</div>
          </v-flex>
          <v-flex xs6 v-if="newSubItem">
            <v-text-field :label="labels.subItemNo" v-model="pkgRiskSubItemForm.subItemNo" :error-messages="errors.collect('subItemNo')" v-validate="'required|numeric|max:10'" data-vv-name="subItemNo" :data-vv-as="labels.subItemNo"></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{labels.subItemNo}}</v-subheader>
            <div class="title">{{pkgRiskSubItemForm.subItemNo}}</div>
          </v-flex>
          <v-flex xs6>
            <v-text-field v-model="pkgRiskSubItemForm.subItemLimit" v-num-mask="{negative: true, intScale: 16, decScale: 2}" :label="labels.subItemLimit" :error-messages="errors.collect('subItemLimit')" data-vv-name="subItemLimit" :data-vv-as="labels.subItemLimit" v-validate="'required'"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-flex xs12>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveGeneral">
        {{ newSubItem ? 'Save Sub Item' : 'Update Sub Item' }}
        <v-icon right>{{newSubItem ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { removeFormatNumber, formatDisplayNumber } from '@/utils/number.js'
export default {
  data() {
    return {
      labels: {
        scheme: 'Scheme',
        planNo: 'Package Plan',
        riskNo: 'Risk No',
        itemNo: 'Item No',
        subItemNo: 'Sub Item No*',
        subItemLimit: 'Sub Item Limit*'
      },
      pkgRiskSubItemForm: {
        scheme: null,
        schemeDesc: null,
        planNo: null,
        planDesc: null,
        riskNo: null,
        itemNo: null,
        subItemNo: null,
        subItemLimit: null,
        subItemDesc: null
      },
      benefitList: [],
      uomList: [],
      submitting: false,
      newSubItem: false,
      menu: []
    }
  },
  computed: {
    pkgRiskItemMenu() {
      return this.$store.state.parameters.scheme.pkgRiskItemMenu
    }
  },
  watch: {
    'ids.subItemNo': function (value) {
      this.resetMessages()
      this.resetValidator()
      this.doClearForm()
      if (value !== 'new') {
        this.newSubItem = false
        if (value !== null) {
          this.fetchData(value)
        }
      } else {
        this.newSubItem = true
      }
    }
  },
  methods: {
    async fetchData(subItemNo) {
      if (!this.newSubItem) {
        const apiURI = this.pkgRiskItemMenu.menu.pkgRiskSubItem
        if (apiURI) {
          try {
            const expand = {
              scheme: this.ids.scheme,
              planNo: this.ids.planNo,
              riskNo: this.ids.riskNo,
              itemNo: this.ids.itemNo,
              subItemNo: subItemNo
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.pkgRiskSubItemForm.scheme = data.pkgRiskSubItem.scheme
              this.pkgRiskSubItemForm.schemeDesc = data.pkgRiskSubItem.schemeDesc
              this.pkgRiskSubItemForm.planNo = data.pkgRiskSubItem.planNo
              this.pkgRiskSubItemForm.planDesc = data.pkgRiskSubItem.planDesc
              this.pkgRiskSubItemForm.riskNo = data.pkgRiskSubItem.riskNo
              this.pkgRiskSubItemForm.itemNo = data.pkgRiskSubItem.itemNo
              this.pkgRiskSubItemForm.subItemNo = data.pkgRiskSubItem.subItemNo
              this.pkgRiskSubItemForm.subItemLimit = formatDisplayNumber(data.pkgRiskSubItem.subItemLimit)
              this.menu = extractMenu(result.data._links)
            } else {
              this.errorMessage('Fail to get Data from the server. please try again')
            }
          } catch (error) {
            const { data } = error.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        } else {
          this.errorMessage('Invalid API URL')
        }
      }
    },
    async doSaveGeneral() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newSubItem) {
            this.doCreateGeneral()
          } else {
            this.doUpdateGeneral()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateGeneral() {
      const apiURI = this.pkgRiskItemMenu.menu.pkgRiskSubItemCreate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.pkgRiskSubItemForm.scheme,
            planNo: this.pkgRiskSubItemForm.planNo,
            riskNo: parseInt(this.pkgRiskSubItemForm.riskNo),
            itemNo: parseInt(this.pkgRiskSubItemForm.itemNo),
            subItemNo: parseInt(this.pkgRiskSubItemForm.subItemNo),
            subItemLimit: removeFormatNumber(this.pkgRiskSubItemForm.subItemLimit)
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab', 4)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doUpdateGeneral() {
      const apiURI = this.menu.pkgRiskSubItemUpdate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.pkgRiskSubItemForm.scheme,
            planNo: this.pkgRiskSubItemForm.planNo,
            riskNo: parseInt(this.pkgRiskSubItemForm.riskNo),
            itemNo: parseInt(this.pkgRiskSubItemForm.itemNo),
            subItemNo: parseInt(this.pkgRiskSubItemForm.subItemNo),
            subItemLimit: removeFormatNumber(this.pkgRiskSubItemForm.subItemLimit)
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab', 4)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.pkgRiskSubItemForm.scheme = this.ids.scheme
      this.pkgRiskSubItemForm.schemeDesc = null
      this.pkgRiskSubItemForm.planNo = this.ids.planNo
      this.pkgRiskSubItemForm.planDesc = null
      this.pkgRiskSubItemForm.riskNo = this.ids.riskNo
      this.pkgRiskSubItemForm.itemNo = this.ids.itemNo
      this.pkgRiskSubItemForm.subItemNo = null
      this.pkgRiskSubItemForm.subItemLimit = null
      this.pkgRiskSubItemForm.subItemDesc = null
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    ids: {
      type: Object,
      default() {
        return {
          scheme: null,
          planNo: null,
          riskNo: null,
          itemNo: null,
          subItemNo: null
        }
      }
    }
  }
}
</script>

<style>
</style>
